module.exports = function() {
  return new Worker(__webpack_public_path__ + "31c1e294e559fbb5ce05.worker.js");
};